import type { UseMyAccountPage } from '~~/types/myaccount/UseMyAccountPage';

import { ROUTES } from '~~/constants/routes';
import { getNameForRoute } from '~~/helpers/routes/getPageInformation';

export const useAccountInternalPage: UseMyAccountPage =
  (route = ROUTES.MY_PROFILE, translationKey: string, iconClass: string) => {

    const { getAdjustedSlug } = useRouteExtended();
    const i18n = useI18n();
    const router = useRouter();

    const isInternal = true;
    const label = i18n.t(translationKey);
    const stringRoute = computed(() => {

      return typeof route === 'object' ? route.value : route;
    
    });

    const adjustedSlug = computed(() => {

      return getAdjustedSlug(stringRoute.value);
    
    });

    const goToThatPage = (): void => {

      router.push(adjustedSlug.value);
    
    };

    const key = computed(() => {

      return getNameForRoute(stringRoute.value);
    
    });

    return {
      label,
      goToThatPage,
      isInternal,
      key,
      adjustedSlug,
      iconClass,
    };
  
  };
